{
  "page": {
    "title": "Reports",
    "subtitle": "Figures are based on bookings paid during the period",
    "exportExcel": "Export Excel"
  },
  "filters": {
    "period": "Period",
    "thisMonth": "This month",
    "sixMonths": "Last 6 months",
    "thisYear": "This year",
    "custom": "Custom range",
    "from": "From",
    "to": "To"
  },
  "stats": {
    "paidBookings": "Paid bookings",
    "fees": "Total fees",
    "shares": "Coordinator shares",
    "net": "Agency net",
    "expenses": "Expenses",
    "profit": "Net profit",
    "profitSub": "Agency net − expenses"
  },
  "chart": {
    "title": "Monthly fees: net and coordinator shares",
    "fees": "Fees: {{value}}",
    "shares": "Coordinator shares: {{value}}",
    "net": "Net: {{value}}",
    "expenses": "Expenses: {{value}}",
    "profit": "Net profit: {{value}}",
    "bookings": "{{n}} bookings",
    "legendNet": "Net",
    "legendShares": "Coordinator shares"
  },
  "tables": {
    "byPartner": "By partner",
    "partner": "Partner",
    "bookings": "Bookings",
    "totalFees": "Total fees",
    "byCoordinator": "By coordinator",
    "coordinator": "Coordinator",
    "totalShares": "Total shares",
    "empty": "No data for this period."
  }
}
